// Pages where Session Replay must never run. These are the public, credential-bearing flows:
// replay records the address bar and the DOM verbatim, including a client's name, amount and
// card form, and beforeSend cannot reach replay's own recording.
//
// Keyed on the route, not on whether the URL still looks token-bearing — the token now lives in
// the fragment and is stripped on load, so any shape-based test would report "safe" here.
export const REPLAY_SUPPRESSED_ROUTES = [
  '/pay',
  '/bank-account',
  '/create-password',
  '/esign-doc',
  '/enrollment',
]

export const isReplaySuppressedPath = (pathname) => {
  const path = pathname || ''
  return REPLAY_SUPPRESSED_ROUTES.some((route) => path === route || path.startsWith(`${route}/`))
}
